import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { api, formatApiError } from "../api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (ev) => {
    ev.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email: email.trim(), password });
      sessionStorage.setItem("lr_admin_token", data.token);
      navigate("/admin/leads", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Não foi possível entrar. Tente novamente."));
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#F7F7F5] px-4 font-body text-[#1A1A1A]">
      <div className="w-full max-w-sm" data-testid="admin-login-page">
        <div className="rounded-[2rem] border border-black/10 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          <span className="grid h-10 w-10 place-items-center rounded-full bg-black font-display text-sm font-extrabold text-white">
            LR
          </span>
          <h1 className="mt-6 font-display text-2xl font-extrabold tracking-tighter">Painel de demonstração</h1>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-black/45">Acesso administrativo</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="mb-2 block font-mono text-[10px] uppercase tracking-[0.18em] text-black/50">
                E-mail
              </label>
              <input
                id="admin-email"
                data-testid="admin-login-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-xl border border-black/15 bg-[#F7F7F5] px-4 py-3 text-sm outline-none transition-colors focus:border-[#1D4E89] focus:bg-white"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="mb-2 block font-mono text-[10px] uppercase tracking-[0.18em] text-black/50">
                Senha
              </label>
              <input
                id="admin-password"
                data-testid="admin-login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-xl border border-black/15 bg-[#F7F7F5] px-4 py-3 text-sm outline-none transition-colors focus:border-[#1D4E89] focus:bg-white"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" role="alert" className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="group flex w-full items-center justify-center gap-2 rounded-full bg-black py-3.5 font-display text-xs font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#1D4E89] disabled:opacity-60"
            >
              {loading ? "Entrando…" : "Entrar no painel"}
              {!loading && <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:rotate-45" />}
            </button>
          </form>
        </div>
        <Link
          to="/"
          data-testid="admin-login-back"
          className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-black/50 transition-colors hover:text-[#1D4E89]"
        >
          <ArrowLeft size={13} />
          Voltar ao site
        </Link>
      </div>
    </div>
  );
}
